import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { EventIcon, EventIcons } from './icons'
import type { Property } from 'csstype'

function emptystr2undefined(x: string | undefined) {
  return x === '' ? undefined : x;
}

@customElement('ep-event-icon')
export class EPEventIcon extends LitElement {

  @property({ reflect: true })
  primary?: Property.Color;

  @property({ reflect: true })
  secondary?: Property.Color;

  @property({ reflect: true })
  icon?: EventIcon;

  render() {
    const primary = emptystr2undefined(this.primary)
    const secondary = emptystr2undefined(this.secondary)
    if (this.icon !== undefined && EventIcons[this.icon] !== undefined) {
      return EventIcons[this.icon](primary, secondary);
    }
    return html``
  }

  static styles = css`
    :host {
      --size: 24px;
      display: inline-block;
      width: var(--size);
      height: var(--size);
    }

    svg {
      width: 100%;
      height: 100%;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-event-icon': EPEventIcon
  }
}
